(function() {
  "use strict";

  angular.module("sempraWebapp").constant("roTranslations", {
    MESSAGE:"Mesaj",
    ERROR_TITLE:"Eroare",
    ERROR_MESSAGE:"A apărut o eroare in executarea operaţiunii.",
    ERROR_LOGIN:"A apărut o eroare in procesul de autentificare. Adresa de E-mail nu este validă",
    ERROR_LOGIN_ROLE:"Aceasta functie nu este valabila pentru aceasta aplicatie",
    OK:"OK",
    CANCEL:"Anulează",
    YES:"Da",
    NO:"Nu",
    FROM:"De la",
    TO:"Pana la",
    DELETE:"Șterge",
    SIGN_OUT:"Deconectare",
    NAME:"Nume",
    DATE:"Data",
    PIECES:"părți",
    HOURS:"Ore",
    DAYS:"Zile",
    MONTH:"Lună",
    MONTHS:"Luni",
    YEAR:"An",
    BOX:"Spaţiu / Boxă de spălare",
    SEARCH:"Caută",
    ALL_USERS:"Toți utilizatorii",
    ARE_YOU_SURE:"Ești sigur",
    BACK:"Inapoi",
    AMOUNT:"Cantitate/Număr",
    DESCRIPTION:"Descriere",
    FORGOT_PASSWORD_ERROR_MSG:"Ceva nu a mers bine. Te rugăm să verfici adresa de e-mail și să incerci din nou",
    REQUIRED_FIELD:"Câmpul este obligatoriu",
    LOGOUT_TITLE:"Sigur dorești să te deconectezi?",
    LOGOUT_MSG:"Toate datele tale nesalvate vor fi pierdute",
    ACTIVATION_ACCOUNT:"Ai activat contul tău cu succes",
    UNKNOWN_ERRROR_NOTIFICATION:"S-a produs o eroare necunoscută",
    CONTINUE:"Continuă",
    DATA_NOT_AVAILABLE:"Datele nu sunt disponibile",
    SELECT:"Selecteaza",
    SELECT_CURRENCY:"Selecteaza moneda",
    UPLOAD:"Încarca",
    PHONE:"Telefon",
    WEBSITE:"Website",
    WORKING_HOURS:"Orele de lucru",
    INSERT:"Insereaza",
    TEXT:"Text",
    CREATED:"Creat",
    VALID_UNTIL:"Valabil pănă la",
    SAVE:"Salvază",
    TOKENS:"Jetoane",
    DELETE_COMPANY_HISTORY:"Ștergeți istoricul companiei?",
    DELETE_COMPANY_HISTORY_MESSAGE:"ATENȚIE: După apăsarea acestui buton, toate tranzacțiile spălătoriei auto vor fi șterse permanent! Aceste date nu pot fi restaurate după ștergere.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Sunteți sigur că doriți să ștergeți permanent toate datele de tranzacție?",
    HISTORY_SUCCESSFULY_DELETED:"Istoricul a fost șters cu succes.",
    HELP:"Ajutor",
    VALUE:"Valoare",
    ACTIVATING_ACCOUNT_ERROR:"A apărut o problemă la activarea contului dvs. R2W.Te rugăm să încerci din nou, dacă problema persistă, contactează asistența noastră la support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Bine ați venit la Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Bun venit la R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Introdu noua parolă și confirmă pentru a activa contul R2W. Vei fi conectat automat la aplicație după aceea.",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Poti modifica mai tarziu in aplicatie setarile utilizatorului",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Kärcher Car Wash",
    RESET_PASSWORD_WELCOME_MSG:"R2W Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Te rog introdu noua parola si confirma pentru a reseta vechea parola. Vei fi automat inregistrat in aplicatie.",
    RESET_PASSWORD_WELCOME_MSG_3:"Poti modifica mai tarziu in aplicatie setarile utilizatorului",
    ENTER_NEW_PASSWORD:"Introdu noua parolă",
    REPEAT_NEW_PASSWORD:"Repetă noua parolă",
    PASSWORD_MIN_LENGTH:"Parola trebuie să aibă cel puțin 8 caractere",
    PASSWORD_MAX_LENGHT:"Parola trebuie să aibă o lungime mai mică de 32 de caractere",
    PASSWORD_PATTERN:"Parola trebuie să conțină cel puțin o literă mare și o literă mică",
    PASSWORD_MATCH:"Parolele nu se potrivesc",
    ACTIVATE:"Activează",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Ai trimis cu succes cererea. Te rog verifică-ți email-ul pentru mesajul de confirmare.",
    VALIDATION_REQUIRED:"Cămp obligatoriu",
    VALIDATION_EMAIL:"Adresa de e-mail nu este validă",
    VALIDATION_INTEGER_NUMBER:"Te rugăm introdu intreaga valoare",
    VALIDATION_HOURS_VALUE:"Valoarea trebuie să fie intre 0-23",
    VALIDATION_MINUTES_VALUE:"Valoarea trebuie să fie intre 0-59",
    VALIDATION_NOT_A_DATE:"Valoarea nu este o dată",
    VALIDATION_FROM:"De la data mai mare până la",
    VALIDATION_TO:"Până în prezent de la",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Această înregistrare există deja în baza de date",
    PASSWORD_VALIDATION_PATTERN_NEW:"Trebuie să existe cel puțin o cifră și o majusculă. Spațiile goale nu sunt permise",
    VALIDATION_PERCENT_VALUE:"Valoarea trebuie să fie între 1 și 999.",
    NUMBERS_ONLY_100:"Numărând până la 100.",
    NUMBERS_ONLY_1000:"Numărând până la 1000.",
    POSITIVE_NUMBERS_ONLY:"Doar numerele de numărare.",
    GRID_PAGER_PAGE:"Pagină",
    GRID_PAGER_ROWS_PER_PAGE:"Randuri per pagină",
    GRID_PAGER_PAGE_OF:"din",
    BREAD_CRUMBS_HOME:"Acasă",
    BREAD_CRUMBS_DASHBOARD_TECH:"Tehnica panoului de bord",
    BREAD_CRUMBS_DETAILS:"Detalii",
    BREAD_CRUMBS_SETTINGS:"Setări",
    BREAD_CRUMBS_WORKING_HOURS:"Orele de lucru",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Raport al totalului banilor pe zile",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Raport al mediei banilor pe ore",
    BREAD_CRUMBS_NEW_USER_GROUP:"Creează grup de utilizatori",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Editează grupul de utilizatori",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Creează șablon de promoție",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Editează șablonul de promoție",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Creează promoție",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Editează promoție",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Sumar periodic",
    LOGIN:"Logare",
    EMAIL:"E-mail",
    PASSWORD:"Parolă",
    LANGUAGE:"Limbă",
    FORGOT_PASSWORD:"Ai uitat parola?",
    SUBMIT:"Execută",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Număr de alarme in așteptare",
    HEADER_VIEW_ALL_ALARMS:"Vezi toate alarmele",
    HEADER_MY_ACCOUNT:"Contul meu",
    HEADER_ACCOUNT_MANAGEMENT:"Administrare cont",
    ACCOUNT_ALREADY_EXIST:"Adresa de E-mail este deja folosită",
    NEWSLETTER_CONFIRMATION:"Trimiteți notificare prin email pentru starea alarmelor",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Prezentarea generală a finanțelor zilnice",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Tehnologia panoului de bord",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Tablou de bord",
    ASIDE_MENU_ALARMS:"Mesaje",
    ASIDE_MENU_FACILITIES:"Facilități",
    ASIDE_MENU_REPORTS:"Rapoarte",
    ASIDE_MENU_REPORT:"Selecteaza raportul",
    ASIDE_MENU_LOYALTY:"Loialitate",
    ASIDE_MENU_USER_GROUPS:"Grupuri de utilizatori",
    ASIDE_MENU_PERIODIC_SUMMARY:"Prezentarea generală periodcă",
    ASIDE_MENU_MANAGING_TOKENS:"Administreaza jetoanele",
    ASIDE_MENU_NEWS:"Noutăți",
    DAILY_FINANCES_TOTAL_MONEY:"Total bani",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Total bani pentru toate facilitățile",
    DAILY_FINANCES_TOTAL_COINS:"Total jetoane metalice utilizate",
    DAILY_FINANCES_DOWNLOAD_CSV:"Descarcă CSV",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Numerar",
    DAILY_FINANCES_CHANGER:"Numerar în schimbător",
    DAILY_FINANCES_COINS:"Jetoane/Eurokey",
    REPORTS_FILTER:"Filtru",
    REPORTS_TYPE_OF_REPORT:"Tip de raport",
    REPORTS_CHOOSE_FACILITY:"Alege unitatea",
    REPORTS_PERIOD_1:"Perioada 1 -",
    REPORTS_PERIOD_2:"Perioada 2 -",
    MONEY_BY_DATE_REPORT:"Total bani până în data de",
    R2W_BY_DATE_REPORT:"Total plăți online până în data de",
    COINS_BY_DATE_REPORT:"Total plăți jetoane până în data de",
    AVG_MONEY_BY_HOUR_REPORT:"Medie a încasărilor pe oră",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Medie a încasărilor pe ziuă a săptămânii",
    AVG_MONEY_BY_BOX_REPORT:"Medie a încasărilot per boxă de spălare",
    COMPARE_PERIODS_REPORT:"Raport comparativ între unități",
    TOTAL_USERS_BY_GROUP:"Total utilizatori din grupuri",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"utilizatori",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"Vizite",
    VISITS_COUNT_REPORT:"Număr de utilizatori per vizită",
    LOYALTY_PER_DAY_REPORT:"Credit de fidelitate dat pe zi",
    LOYALTY_PER_PAYMENT_METHOD:"Loialitatea oferită in funcție de metoda de plată",
    VISITS:"Vizite",
    VISIT:"Vizită",
    TOTAL_SPENT_MONEY:"Bani cheltuiți in total",
    MONEY:"Bani",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Bani cheltuiți in total pentru perioada",
    DOWNLOAD_CSV:"Descarcă CSV",
    TOTAL_SPENT_COINS:"Total jetoane utilizate",
    TOTAL_USERS:"Total utilizatori",
    TOTAL_CREDIT_GIVEN:"Total credite acordate",
    EUROKEY_BY_DATE_REPORT:"Total plăți Eurokey pe date",
    TOTAL_SPENT_EUROKEY:"Total cheltuit",
    SELECT_TYPE_OF_REPORT:"Trebuie să selectați tipul de raport",
    NUMBER_OF_VISITS_TITLE:"Numărul de vizite",
    NUMBER_OF_USERS_TITLE:"Numărul de utilizatori",
    PIECES_TITLE:"Bucăți",
    TOTAL_VISITS:"Total vizite",
    TOKENS_TITLE:"Tokenuri",
    SEARCH_USERS_NO_RESULTS:"Nu au fost găsiți utilizatori pentru termenul de căutare dat",
    SEARCH_USERS:"Căută utilizatori",
    SEARCH_TELEPHONES:"Căută utilizatori după numărul de mobil",
    ADD_USER_TO_GROUP:"Adaugă utilizatorul la grup",
    REMOVE_USER_FROM_GROUP:"Elimină utilizatorul din grup",
    USER_GROUP_NAME_REQUIRED:"Numele grupului de utilizatori este necesar",
    USER_GROUP_NAME:"Numele grupului de utilizatori",
    USER_GROUPS_OVERVIEW:"Vizualizarea grupurilor de utilizatori",
    USER_COUNT:"Numărul utilizatorilor",
    NEW_USER_GROUP:"Creeaza un nou grup de utilizatori",
    DELETE_USER_GROUP:"Șterge grupul de utilizatori",
    UPDATE_USER_GROUP:"Editează grupul de utilizatori",
    DELETE_USER_GROUP_ERROR:"A apărut o eroare la ștergerea grupului de utilizatori selectat. Înceră din nou sau contactează asistența ...",
    CONFIRM_DELETE_USER_GROUP:"Sigur doreşti să ștergi grupul de utilizatori selectat?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Acțiunile de loialitate care au fost acordate grupului eliminat nu vor mai fi aplicate.",
    GROUP_NAME_MAX_LENGTH:"Numele grupului trebuie să aibă o lungime mai mică de 255 de caractere",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Utilizatorul este deja în acel grup",
    MISSING_USER:"Utilizator lipsă",
    USER_NOT_ON_LIST:"Utilizatorul nu se află în lista utilizatorilor activi. Verificați dacă adresa de email este validă și încercați din nou.",
    UPLOAD_USER_GROUP:"Încărcați lista de grupuri de utilizatori din fișierul *.csv",
    UKNOWN_USERS:"Listă de utilizatori necunoscuți",
    CAMPAIGN_TEMPLATE_RULE:"Regula de șablon",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"A apărut o eroare în timp ce încercai să ștergi șablonul de campanie. Încercă din nou sau contactați asistența ...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Sigur dorești să ștergi șablonul de campanie selectat",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Prezentare generală a șabloanelor de campanie",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Șterge șablonul de campanie",
    DELETE_CAMPAIGN_TEMPLATE:"Editează șablonul de campanie",
    UPDATE_CAMPAIGN_TEMPLATE:"Creează un nou șablon de campanie",
    CREATE_CAMPAIGN_TEMPLATE:"Este cerut numele șablonului de campanie",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Numele șablonului campaniei",
    CAMPAIGN_TEMPLATE_NAME:"Câmp necesar",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Oferă",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"dați %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"timp suplimentar",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Vă rugăm să selectați tipul întâi. Casete de spălat sau Mașini mici.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Șterge regula șablonului",
    CAMPAIGN_TEMPLATE_RULE_FROM:"De la",
    CAMPAIGN_TEMPLATE_RULE_TO:"pana la",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"ore",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minute",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Noua regulă în funcție de numărul de vizite",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Noua regulă în funcție de banii cheltuiți",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Noua regulă în funcție de zilele săptămânii",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Adăugă o regulă nouă pentru șablon",
    CAMPAIGN_TEMPLATE_RULE_1:"Fiecare",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Fiecare",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"credite cheltuite în mai puțin de",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"vizite in mai puțin de",
    CAMPAIGN_TEMPLATE_RULE_3:"zile",
    CAMPAIGN_TEMPLATE_RULE_4:"credite",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Lista de reguli este goală",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Data nu poate fi din trecut",
    DELETE_CAMPAIGN_ERROR:"A apărut o eroare în timp ce încercai să ștergi campania. Încercă din nou sau contactează asistența ...",
    CONFIRM_DELETE_CAMPAIGN:"Sigur dorești să ștergi campania selectată?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W nu este responsabil pentru experiența utilizatorului cauzată de această acțiune.",
    CAMPAIGNS_OVERVIEW:"Afișarea campaniilor",
    DELETE_CAMPAIGN:"Șterge campanie",
    UPDATE_CAMPAIGN:"Editează campanie",
    CREATE_CAMPAIGN:"Creează o nouă campanie",
    CAMPAIGN_ACTIVE:"Activ",
    CAMPAIGN_TEMPLATE:"Șablon",
    CAMPAIGN_GROUPS:"Grupuri",
    CAMPAIGN_ALL_USERS:"Toți utilizatorii",
    CAMPAIGN_NAME:"Numele campaniei",
    CAMPAIGN_NAME_REQUIRED:"Necesar",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Numărul de utilizatori din apropierea pragului pe zi",
    MESSAGE_TO_USERS:"Mesaj către utilizatorii filtrați",
    SEND_MESSAGE:"Trimite mesaj",
    THRESHOLD:"Prag",
    TYPE:"Tip",
    TOTAL_MONEY_SPENT:"Total bani cheltuiți in campanie",
    NUMBER_OF_VISITS:"Număr de vizite in cadrul campaniei",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Mesajul trebuie să aibă cel puțin 10 caractere",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Mesajul trebuie să aibă mai puțin de 350 de caractere",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Textul mesajului este necesar",
    TECHNOLOGY:"Tehnologie",
    TAP_WATER:"Apă de la robinet",
    REVERSE_OSMOSIS:"Osmoză inversă",
    SOFTENED_WATER:"Apă dedurizată",
    DOSER:"Dozator",
    STATUS:"Statut",
    LAST_SYNCHRONIZATION:"Ultima sincronizare",
    NO_OF_CURRENT_ALARMS:"Numărul de alarme curente",
    NO_OF_CURRENT_WARNINGS:"Numărul de avertizări curente",
    WEATHER:"Vreme",
    BOXES_WORK_HOURS_COUNTERS:"Program de lucru al boxelor de spălare",
    BOX_TOTAL_HOURS:"Total ore de lucru",
    BOX_SERVICE_HOURS:"Total ore de lucru (servicii)",
    BOX_COUNTER_HOURS:"ore",
    ALARMS_AND_WARNINGS:"Alarme & avertizări",
    FILTER_AND_BOILER:"Filtru & boiler",
    FILTER_TOTAL_DAYS:"Zile de muncă filtru",
    BOILER_TOTAL_DAYS:"Zile de muncă boiler",
    DAYS_UNIT:"zile",
    SOFTENER:"Balsam",
    MANUAL_COLD_DRAIN:"Scurgere manuală la rece",
    EL_COLD:"El. Rece",
    DRAIN:"scurgere",
    TAP:"robinet",
    WASTE:"Deșeuri",
    OSMOSIS:"osmoză",
    DEMI_WATER:"Demi-apă",
    EL_RINSE:"El. m. clătire",
    BOILER:"Boiler",
    EL_WAX:"El. m. ceară",
    FLOOR_HEATING:"Înclazire în podea",
    DOSER_TANK:"Bazin dozator",
    EL_WASH:"El. m. spălare",
    DETERGENT:"Detergent",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Actualizează setările",
    GENERAL_SETTINGS:"Setări generale",
    LIGHTS:"Lumini",
    GROUPS:"Grupuri",
    ANTI_FREEZE:"Antigel",
    AUTO:"Auto",
    MANUAL:"Manual",
    ON:"Pornit",
    OFF:"Oprit",
    TEMPERATURE:"Temperatură",
    UPDATE_DEVICE:"Actualizează setările unității",
    BOX_CLEAN_HOURS:"Număr de ore de curăţienie in boxa de spălare",
    GROUP_COUNTERS:"Contoare de grupuri",
    RESET:"Resetează",
    CASH_COUNT:"Număr monezi",
    COINS_COUNT:"Număr jetoane",
    EUROKEY_COUNT:"Număr Eurokey",
    DOSER_WORK:"Timp de funcționare a dozatorului (sec)",
    DOSER_PAUSE:"Pauză dozator (sec.)",
    DELAY_BFV:"Întârziere BFV (ms)",
    DELAY_6M1:"Întârziere 6M1 (ms)",
    DELAY_LPS:"Întârziere LPS (ms)",
    RESET_CASH_COUNT_ALL:"Resetează toată numărătoarea monedelor",
    RESET_COINS_COUNT_ALL:"Resetează toată numărătoarea jetoanelor",
    RESET_EUROKEY_COUNT_ALL:"Resetează toată numărătoarea Eurokey",
    FACILITY_DETAILS:"Detalii unități",
    FACILITY_NAME:"Nume unități",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Ai încărcat cu succes imaginea",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Ai actualizat datele cu succes",
    CONNECTED:"Conectat",
    DISCONNECTED:"Deconectat",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Filtrul de mesaje",
    FACILITY:"Unitate",
    APPLY:"Aplică",
    TIME:"Timp",
    LOCATION:"Locație",
    ACKNOWLEDGED:"Recunoscut",
    FILTERED_MESSAGES:"Mesaje filtrate",
    ACK:"Recunoscute",
    NOT_ACK:"Nerecunoscute",
    ALL:"Tot",
    ALL_FACILITIES:"Toate facilitățile",
    ENTER_DATE_PLACEHOLDER:"Introdu dată",
    OP_NESTANAK_NAPONA:"Lipsește voltajul pe indicatorul de fază 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"S-a stricat întrerupătorul pompei de înaltă presiune",
    OP_UPR_NAPON_24VAC_GRE:"Lipsește 24 VAC - Întrerupator 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Rezervorul de apă proaspătă este gol",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Întrerupătorul circuitului pompei de apă a scăzut",
    OP_MIN_NIVO_OMEKS_VODE:"Rezervorul de apă dedurizată",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Întrerupătorul pompei de apă dedurizată s-a stricat",
    OP_MIN_NIVO_DEMIN_VODE:"Rezervorul de apă de osmoză este gol",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Întrerupătorul pompei de apă de osmoză s-a stricat",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Întrerupătorul pompe de producție a de apei de osmoză s-a stricat",
    OP_BOJLER_GRESKA_MZS:"Eroare la încălzirea apei",
    OP_CRPKA_PRASKA_GRE_MZS:"Întrerupătorul circuitului pompei de apă caldă s-a stricat",
    OP_DOZATOR_PRASKA_GRE_MZS:"Dispozitivul pentru întreruperea motorului de dozare a pulberilor s-a stricat",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Pulverizatorul de vibrații de dozare a pulberii s-a stricat",
    OP_MIN_PRASAK_TON_ALARM:"Rezervorul de amestecare a pulberii este gol",
    OP_USIS_KOV_TURBINA_GRESKA:"Montajul aspiratorului turbină s-a stricat",
    OP_FILTER_VODE_ZACEPLJEN:"Filtrul de apă este blocat",
    OP_VISKTL_RESET_SATI_RADA:"Pompă de înaltă presiune - service",
    OPW_VISKTL_RESET_SATI_RADA:"Pompă de înaltă presiune - service",
    OP_FILTER_DANI_RADA:"Defecțiune la filtrul de apă",
    OP_BOJLER_DANI_RADA:"Defecțiune la încălzitorul de apă",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarma pompei de înaltă presiune",
    OPW_ALARM_FILTER_SERVIS:"Alarmă de serviciu filtru",
    OPW_ALARM_BOJLER_SERVIS:"Alarmă de serviciu boiler",
    HAS_MEMBERS:"Grupul selectat are membri și nu poate fi șters. Mai întâi trebuie șterși membrii.",
    PERIODIC_SUMMARY_FOR:"Rezumatul raportului periodic R2W pentru",
    PERIODIC_SUMMARY_REPORTS:"Rapoartele periodice",
    DATE_RANGE:"Interval de date",
    FINANCIAL_REPORT:"Raport financiar",
    GROSS_INCOME:"Venit brut",
    GROSS_INCOME_SUM:"Sumă venit brut",
    COMMISSION_FEE:"Comision",
    NET_INCOME:"Venitul net (pentru facturare)",
    COMMISSION_FEE_DETAILS:"Taxa de comision include comisionul bancar / furnizor PayPal sau furnizorul de servicii SMS.",
    LOYALTY_CREDITS_REPORT:"Raport de credite de loialitate",
    LOYALTY_GIVEN:"Credite de loialitate acordate",
    LOYALTY_USED:"Credite de loialitate folosite",
    LOYALTY_SOLD:"Credite de loialitate vândute",
    LOYALTY_TOTAL:"Total",
    LOYALTY_CURRENT_MONTH:"Luna curentă",
    SOMETHING_WENT_WRONG:"Oooops",
    MISSING_PAGE:"Scuze. Nu am putut găsi pagina",
    TRY_AGAIN:"Incearcă din nou",
    DEFAULT_ERROR_NAME:"Eroare necunoscută",
    DEFAULT_ERROR_DESCRIPTION:"Te rugăm încearcă din nou",
    MY_ACCOUNT_DETAILS:"Detaliile contului meu",
    SAVE_CHANGES:"Salvează modificările",
    USERNAME:"Nume utilizator",
    FIRST_NAME:"Nume mic",
    LAST_NAME:"Nume mare",
    USER_ROLE:"Rol utilizator",
    OLD_PASSWORD:"Parolă veche",
    NEW_PASSWORD:"Parolă nouă",
    OLD_PASSWORD_REQUIRED:"Este necesară parola veche",
    NEW_PASSWORD_REQUIRED:"Este necesară parola nouă",
    NEW_PASSWORD_REPEAT:"Este nevoie sa repetați noua parolă",
    NEW_PASSWORD_NOT_MATCH:"Parola veche cu parola nouă nu se potrivesc",
    PASSWORD_DIFFERENT_VALIDATION:"Parola nouă trebuie să fie diferită de cea veche",
    PASSWORD_MIN_CHAR:"Parola dvs. trebuie să aibă cel puțin 8 caractere",
    PASSWORD_MAX_CHAR:"Parola dvs. trebuie să aibă maximum 32 de caractere",
    PASSWORD_PATTERN_VALIDATION:"Parola trebuie să conțină cel puțin un număr",
    ACCOUNT_MANAGEMENT:"Managementul contului",
    NOT_ACTIVE:"Inactiv",
    ASSIGN_ROLE:"Atribuie rolul",
    UPDATE:"Actualizează",
    ADD_NEW_ACCOUNT:"Adaugă un cont nou",
    EMAIL_REQUIRED:"Este necesară o adresă de e-mail",
    EMAIL_NOT_VALID:"Adresa de email nu este validă",
    ADD_NEW_USER_TEXT:"E-mailul cu linkul de activare va fi trimis la adresa de e-mail furnizată.",
    UPDATE_USER_NOTIFICATION:"Ai actualizat informațiile cu succes",
    CHANGED_PASSWORD_NOTIFICATION:"Ai schimbat cu succes parola",
    UPDATE_USER_GROUP_NOTIFICATION:"Ai actualizat cu succes numele grupului de utilizatori",
    CREATE_USER_GROUP_NOTIFICATION:"Ai creat grupul cu succes",
    DETELE_USER_GROUP_NOTIFICATION:"Ai șters grupul cu succes",
    EMPTY_GROUP_LIST_MSG:"Nu există grupuri create. Începe prin a crea unul",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Ai șters cu succes utilizatorul din grup",
    ADD_USER_TO_GROUP_NOTIFICATION:"Ai adăugat cu succes utilizatorul în grup",
    ADD_USER_NOTIFICATION:"Ai adăugat cu succes un utilizator nou",
    DELETE_USER_NOTIFICATION:"Ai șters cu succes utilizatorul",
    RESEND_USER_VERIFICATION_EMAIL:"Emailul de verificare a fost retransmis cu succes",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Pentru a crea un grup de utilizatori",
    DELETE_USER:"Șterge utilizatorul",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Sigur doriești să ștergi utilizatorul din grupul de utilizatori?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Dragă utilizator R2W",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Regula de loialitate pentru numărul de vizite",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Regula de loialitate pe suma de bani cheltuită",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Regula de loialitate în funcție de ziua din săptămână",
    REMOVE_CAMPAIGN_RULE_TITLE:"Eliminarea regulii de campanie",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Sigur dorești să elimini regula campaniei?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Ai creat cu succes o nouă campanie",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Ai activat campania",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Nu există campanii create. Începe prin a crea una",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Ai trimis cu succes mesajul",
    COMPANY_ACCOUNTS:"Conturile companiei",
    BUSSINESS_INVOICES_LIST:"Facturile mele B2B",
    LOCALE_TOKEN:"Jetone local",
    R2W:"Jetone global",
    START_MONTH:"Începutul lunii",
    END_MONTH:"Sfârșitul lunii",
    TOKEN_TYPE:"Tipul de token",
    TOKEN_NUMBER:"Numărul tokenului",
    NOTHING_TO_DISPLAY:"* Nimic de afișat",
    CREATE_INVOICE:"Creați factură",
    INVOICE:"Factura fiscala",
    INVOICES:"Facturi",
    EDIT_INVOICE:"Editează factura",
    UPDATE_INVOICE_NOTIFICATION:"Ai actualizat cu succes factura în starea în așteptare",
    CURRENT_CHARGES:"Taxele pentru perioada curentă",
    PAYMENTS_ON_HOLD:"Facturi în procesare",
    FOR_INVOICING:"Pentru facturare",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Ești pe cale să anulezi factura",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Sigur dorești să anulezi această factură?",
    INVOICING_NOTIFICATION_HEADER:"Esti pe cale să faci facturarea",
    INVOICING_NOTIFICATION_TEXT:"Sigur doreșt să trimiți factura?",
    SENT_INVOICE_NOTIFICATION:"Ai trimis cu succes o factură",
    CANCELED_INVOICE_NOTIFICATION:"Ai anulat factura",
    INVOICE_DESCRIPTION_TEXT:"Factură pentru",
    INVOICE_STATE:"Starea facturii",
    INVOICE_NUMBER:"Numărul facturii",
    INVOICE_TOTAL:"Total",
    SELECT_YEAR:"Selectează an",
    DOWNLOAD:"Descarcă PDF",
    INVOICE_NUMBER_HEADER:"Ești pe cale să trimiti factura cu numărul",
    INVOICE_PAYMENT_CONFIRMATION:"Ești pe cale să confirmi plata pentru",
    INSERT_INVOICE_NUMBER:"Introdu numărul facturii",
    INVOICED_WARNING:"E-mailul nu a fost trimis. Te rog asteapta ...",
    SEND_INVOICE:"Trimite",
    INVOICE_ALL:"Toate",
    INVOICE_FROM_R2W:"De la R2W",
    INVOICE_TO_R2W:"Către R2W",
    PAYMENT_REQUEST:"Cerere de plată",
    PAYMENT_REQUEST_STATE:"Stare cerere de plată",
    PAYMENT_REQUEST_NUMBER:"Număr cerere de plată",
    FOR_PAYMENT_REQUEST:"Pentru cererile de plată",
    PAYMENT_REQUEST_ON_HOLD:"Cererile de plată în proces",
    DOWNLOAD_INVOICE:"Descarcă factura",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Click pentru opțiuni de descărcare",
    B2B_SPEC:"Specificație B2B",
    B2C_SPEC:"Specificație B2C",
    DOWNLOAD_PAYMENT_REQUEST:"Descarcă cererea de plată",
    LOYALTY_PREVIEW:"Previzualizare loialitate",
    ACTIVATED:"Activat",
    RUNNING:"Functionează",
    NOT_ACTIVATED:"Nu este actviat",
    FINISHED:"Terminat",
    DEPRECATED:"Depreciată",
    UPCOMING:"Pe cale să se întâmple",
    NONE:"Nici unul",
    STARTED:"A început",
    ENDS:"Se termină",
    DEDICATED:"Dedicat pentru",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Sunteți pe punctul de a activa",
    CAMPAIGN:"campanie",
    SEND_MESSAGE_NOTIFICATION:"Sunteți pe cale să trimiteți mesaje către grupurile de utilizatori selectate",
    DIVISIBLE_TO_NUMBER:"Numărul trebuie să fie divizibil cu",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Tipul dispozitivului",
    LISTENER:"Mașini mici",
    BRIDGE:"Boxe de spălare",
    WASH_BOXES:"Boxe de spălare",
    VACUUMS:"Aspiratoare",
    SAVE_NEWS:"Salvează știrile",
    CREATE_NEW_NEWS:"Creați noi știri",
    HISTORY_OF_ALL_NEWS:"Istoria tuturor știrilor",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Introduceți numele facilității",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Adăugați o altă facilitate",
    NEWS_TEXT:"Știri text",
    NEWS_TITLE:"Titliu Știri",
    DELETE_NEWS_CONFIRMATION:"Ești pe cale să ștergi știri",
    NEWS_DELETE_NOTIFICATION:"Ai șterges cu succes știrile",
    NEWS_SAVE_NOTIFICATION:"Ai salvat știrile",
    NEWS_CREATION_DATE:"Data creării",
    NO_TITLE:"Fără nume",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Textul de știri trebuie să fie mai mic de 255 de caractere",
    NEWS_TEXT_REQUIRED_VALIDATION:"Este necesar un text de știri",
    NEWS_TITLE_REQUIRED_VALIDATION:"Este necesar titlul știrii",
    DEACTIVATE:"Dezactivează",
    ASIDE_MENU_LOCAL_TOKENS:"Jetoane locale",
    CREATE_NEW_LOCAL_TOKENS:"Emite noi jetoane locale",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Introdu adresa de e-mail a clientului și cantitatea de jetoane locale pe care dorești să le emiți clientului",
    CREATE_TOKENS:"Etichete de emitere",
    MINIMUM_ONE_TOKEN:"Valoarea trebuie să fie mai mare de 0",
    CUSTOMER_EMAIL:"E-mail client",
    AMOUNT_OF_TOKENS:"Numărul de jetoane",
    ISSUING_LOCAL_TOKENS_SUCCESS:"S-a realizat cu succes emiterea de jetoane locale către",
    PROBLEM_ISSUING_LOCAL_TOKENS:"A apărut o eroare la emiterea jetoanelor locale.Verificați adresa de e-mail a clientului și încercați din nou.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Privire de ansamblu asupra jetoanelor locale emise",
    ISSUED_AT:"Emis la",
    ISSUED_BY:"Emis de",
    CODE:"Cod promotional",
    REDEEMED_BY:"Folosește pănă la",
    REDEEMED_AT:"Folosește la",
    ASIDE_MENU_VOUCHERS:"Vouchere",
    PRINT:"Printează",
    VOUCHERS_OVERVIEW:"Prezentare generală a voucherelor",
    CREATE_NEW_VOUCHERS:"Creează vouchere noi",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Creează un nou lot de vouchere rambursabile, introducând suma de jetoane pentru fiecare voucher",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Cantitatea de jetoane per voucher",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Poți aloca între 1 și 20 de jetoane pentru fiecare voucher",
    NUMBER_OF_NEW_VOUCHERS:"Numărul de vouchere care urmează a fi create",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Poți crea vouchere între 1 și {{size}} într-un singur lot",
    NEW_VOUCHERS_PREFIX:"Prefixul codului de serie al voucherelor noi",
    VALIDATION_VOUCHER_PREFIX:"Prefixul de cod trebuie să fie din caractere superioare și între 1 și 16 litere și/sau caractere numerice",
    PROBLEM_CREATING_NEW_VOUCHERS:"A apărut o problemă la crearea de vouchere noi.Încercați din nou sau contactați asistența noastră.",
    CREATE_VOUCHERS:"Creează vouchere",
    CREATING_VOUCHERS_SUCCESS:"Noi vouchere create cu succes",
    PRINT_NEW_VOUCHERS:"Imprimați vouchere",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Introdu un prefix de cod de serie al voucherului pentru a imprima o serie întreagă de vouchere.",
    PRINT_VOUCHERS_PREFIX:"Codul prefixului voucher (serie)",
    NO_VOUCHERS_FOR_PRINT:"Nu au fost găsite vouchere care să corespundă prefixului codului furnizat pentru tipărire",
    PRINT_VOUCHERS:"Imprima voucher(e)",
    VALIDATION_VOUCHER_CODE_FILTER:"Termenul de căutare a cuponului trebuie să conțină litere mari și numere",
    FILTER_VOUCHERS_BY_CODE:"Căută vouchere prin introducerea codului",
    FILTER_VOUCHERS:"Căută vouchere",
    WASH_BOX:"Boxă de spălare",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Total jetoane digitale utilizate",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:" Total vândute jetoane locale după dată",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Total cheltuite jetoane locale după dată",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Total acordate jetoane locale după dată",
    LOCAL_TOKEN:"Jeton local",
    GIVEN_TOKEN:"Jetoni locali acordați",
    SOLD_TOKEN:"Jetoni locali vânduți",
    SMALL_MACHINES:"Mașini mici",
    R2W_Listener:"Ascultător",
    HHANLE_DEVICE:"Boxă de spălare HHanle",
    CODE_PREFIX_EXIST:"Prefixul codului există deja",
    CODE_PREFIX_EXIST_TEXT:"Nu puteți crea un cupon nou cu acest prefix de cod. Vă rugăm să setați altul.",
    MIN_FOUR_VALIDATION:"Exact 4 caractere",
    ALL_INFORMATION_1:"Toate informațiile despre",
    ALL_INFORMATION_2:"vor fi pierdute",
    ASIDE_MENU_TRANSACTIONS:"Tranzacții",
    EXPENSES:"Cheltuieli",
    TOPUPS:"Încărcări",
    EXPENSES_LIST:"Listă de cheltuieli",
    USER_EMAIL:"Adresa de email a utilizatorului",
    COMPANY_NAME:"Numele companiei",
    TOPUPS_LIST:"Listă de reîncărcări",
    CONSUMER:"Consumator",
    SYSTEM_ADMIN:"Administrator de sistem",
    MERCHANT_ADMIN:"Administrator comerciant",
    COMPANY_ADMIN:"Administrator companie",
    FACILITY_ADMIN:"Facility administrator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Număr de serie",
    SETUP_UNIT_MATERIAL_NO:"Număr de material",
    SETUP_UNIT_WEBAPI_VERSION:"Versiune WebApi",
    TOTAL_TURNOVER:"Volum de afaceri al facilității de spălare",
    AVAILABILITY_ALL:"Disponibilitate",
    AVAILIBILITY:"Disponibilitatea boxelor de spălare:",
    AVAILABILITY_VACUUMS:"Disponibilitatea aspiratoarelor:",
    WASH_BOX_INFO:"Informații despre boxele de spălare",
    VACUUM_CLEANER_INFO:"Informații despre aspiratoare",
    BREAD_CRUMBS_SERVICE:"Serviciu",
    HOLIDAYS:"Zilele libere ",
    HOLIDAY:"Zi libera",
    LIGHTS_ON:"Luminile pornite",
    LIGHTS_OFF:"Luminile oprite",
    WASH_BOXES_ON:"Box de spălare pornit",
    WASH_BOXES_OFF:"Box de spălare oprit",
    VACUUMS_ON:"Aspiratoare pornite",
    VACUUMS_OFF:"Aspiratoare oprite",
    TURNOVER:"Încasări",
    TURNOVER_MANUAL_WASH_UNIT:"Încasări manuale",
    STATUS_BAY_RUN_TIME:"Timp total de funcționare al boxului de spălat",
    STATUS_BAY_PROGRAM_NAME:"Numele programului",
    STATUS_BAY_CREDIT:"Credit pentru boxul de spălat",
    CLOUD_KREDIT:"Credit de pe cloud",
    STATUS_VACUUM_RUN_TIME:"Timp total de funcționare al aspiratoarelor",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Informații despre serviciile facilității, programul boxului de spălat și datele curente despre defecte",
    UNAVAILABLE:"Unitate indisponibilă",
    SHOW_HIDE_TABLE:"Afișare/ascundere tabel de ore de lucru",
    PROGRAM_NAME:"Numele programului",
    PROGRAM_COUNTER:"Contorul programului",
    NO_NAME:"Referința nu are nume",
    COUNTER_SERVICE_DATA:"Date despre serviciu",
    NEED_SERVICE:"Necesita service",
    PROGRAM_DATA:"Date despre programul boxului de spălat",
    CURRENT_FAULT_DATA:"Date curente despre defecte",
    REFERENCE_DUE:"Scadență",
    REFERENCE_SECONDS:"Secunde",
    REFERENCE_NAME:"Nume piesă",
    WASHBOX_NAME:"Nume box de spălat",
    FAULT_NAME:"Nume defect",
    FAULT_NUMBER:"Număr defect",
    CURRENT_FAULT_COUNT:"Defecte active",
    DEVICE_NOT_INSTALLED:"Dispozitiv neinstalat",
    STATUS_READY:"Stare gata",
    STATUS_ERROR:"Starea erorii",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Eroare software",
    SOFTWARE_RESET:"Eroare software",
    EXTERNAL_PIN_RESET:"Eroare software",
    RESTART_OR_BROWNOUT_OCCURRED:"Eroare software",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Eroare hardware",
    COULD_NOT_SIMULATE_COIN:"Eroare hardware",
    ERROR_SETTING_INHIBIT_MODE:"Eroare hardware",
    OFFLINE_DEVICE:"Spălătorie offline",
    TARIFFS:"Tarife",
    DAY:"Zi",
    NIGHT:"Noapte",
    VOUCHER_CODE:"Cod voucher",
    DISMISS_ALARM:"Resetezi alarma?",
    ALARM_ACTIVE:"Alarme active",
    NO_ALARM_ACTIVE:"Nu exista alarme active",
    ALARM_HISTORY:"Istoric alerte",
    MANAGING_TOKENS:"Administreaza jetoanele",
    EXPIRATION_DATE:"Data expirării",
    EXTEND_TOKEN_DATE:"Extindeți data de expirare a simbolului pentru",
    DELETE_TOKENS_FOR:"Ștergeți jetoanele pentru",
    PUMP_TYPE:"Tipul de pompa",
    TURN_OFF_DEVICE:"Starea echipamentului",
    OPERATION_DATA:"Date de operare",
    PUMP_DATA:"Date pompa",
    PUMP_NAME:"Nume pompa",
    POINT_NAME:"Nume punct",
    CHANGER_INCOME:"Total venit bancomat dupa data",
    SELECTED_OPEN:"Deschis la orele de lucru selectate",
    ALWAYS_OPEN:"Intotdeauna deschisa (24/7)",
    CLOSED:"Închis",
    CLOSED_24:"Inchis 24 ore",
    OPENED_24:"Deschis 24 ore",
    MON:"Luni",
    TUE:"Marți",
    WED:"Miercuri",
    THU:"Joi",
    FRI:"Vineri",
    SAT:"Sâmbătă",
    SUN:"Duminică",
    PRICING:"Stabileste pretul",
    PRICE:"Pret",
    VALIDITY:"Valabilitate",
    TOKEN_PACKAGES:"Pachete de jetoane",
    SINGLE_WASH:"O singura spalare",
    FACILITY_WORKING_HOURS:"Stabileste orarul de functionare pentru spalatoria selectata",
    WORKING_HOURS_ALWAYS_OPEN:"Intotdeauna deschisa",
    WORKING_HOURS_ALWAYS_CLOSE:"Inchisa de operator",
    WORKING_HOURS_CUSTOM:"Stabileste orele de functionare",
    KARCHER_ERROR_CODE:"Alerta cod eroare",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor buffer tank empty activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor buffer container empty and buffer contianer full switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor ro pump on and buffer container full switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizatia",
    CREATE_ORGANIZATION:"Creaza organizatia",
    CREATE_ORGANIZATION_AS:"Creaza organizatia ca filiala a",
    DELETE_ORGANIZATION:"Sterge organizatia",
    EDIT_ORGANIZATION:"Editeaza organizatia",
    SUPPORTED_ORG_NAME:"Organizatie sustinuta",
    SUPPORTED_ORG_TYPE:"Tip de sustinere",
    ORG_NAME:"Nume",
    ORG_TYPE:"Tip",
    SET_ORG_TITLE:"Setati filiala organizatiei",
    SET_SUPPORTED_ORG_TITLE:"Setati filiala organizatiei sustinuta",
    SAVE_ORGANIZATION:"Salveaza organizatia",
    SELECT_ORGANIZATION_TYPE:"Selecteaza tipul organizatiei",
    SELECT_ORGANIZATION_SELECTOR:"Selecteaza",
    SELECT_SUPPORTED_ORGANIZATION:"Selecteaza organizatia sustinuta",
    ORGANIZATION_DELETED:"Organizatia a fost stearsa",
    ORGANIZATION_SAVED:"Organizatia a fost salvata cu succes",
    ORGANIZATION_UPDATED:"Organizatia a fost actualizata cu succes",
    ALERTS:"Alerte",
    DEVICE_STATUS:"Starea echipamentului",
    SITE_DETAILS:"Detaliile locatiei",
    ALARM_STATUS:"Status alerta",
    FILTER:"Filtrare ...",
    FILTER_BY_ALERT_CENTER:"Filtrare dupa cod, nume sau descriere",
    TOTAL_ALARM:"Total",
    LOW_ALARM:"Incident/ eveniment",
    MEDIUM_ALARM:"Defectiune",
    HIGH_ALARM:"Defectiune critica",
    NO_FACILITIES_NEARBY:"Nu exista locatii in apropiere",
    GRAY_MAP:"Harta in stil gri",
    READY:"Este gata",
    WARNING:"Defectiune",
    ERROR:"Eroar",
    SITE_NAME:"Nume locatie",
    ACCOUNTS_INFO:"Informatii cont",
    USER_ORGANIZATION:"Utilizator organizatie",
    ADD_USER_ORGANIZATION:"Adauga un nou utilizator al organizatiei",
    EDIT_USER_ORGANIZATION:"Editeaza utilizatorii organizatiei",
    SELECT_ROLE:"Selecteaza rolul",
    SELECT_ORGANIZATION:"Selecteaza organizatia",
    SELECT_USER:"Selecteaza utilizatorul",
    USER_FOR_ORGANIZATION_CREATED:"Un nou utilizator a fost creat cu succes",
    SELECT_REGION:"Selecteaza regiunea",
    SELECT_LANGUAGE:"Selecteaza limba",
    LOADING_DATA:"Se incarca, te rog sa astepti…",
    ADMINISTRATOR:"Administrator",
    TECHNICAL_SUPPORT:"Suport tehnic",
    CONTROLLER:"Supervizor",
    EDIT_ORGANIZATION_USER:"Editeaza utilizatorii organizatiei tale",
    DELETE_ORGANIZATION_USER:"Sterge utilizatorii organizatiei tale",
    USER_UPDATED:"Utilizator actualizat cu succes",
    USER_CREATED:"Utilizator creat cu succes",
    ADDRESS:"Adresa",
    SUBSCRIPTIONS:"Abonamente",
    RESOLVED_STATUS:"Rezolvat",
    NOT_RESOLVED_STATUS:"Nu s-a rezolvat",
    ALERT_NAME:"Nume alerta",
    ALERT_DESCRIPTION:"Descriere alerta",
    ALERT_CODE:"Cod alerta",
    ALERT_TYPE:"Tip alerta",
    UNSUBSCRIBE:"Alerta dezabonare",
    SUBSCRIBE:"Alerta abonare",
    ALARM_SUBSCRIBED:"Te-ai abonat cu succes",
    UNSUBSCRIBED_CONFIRM:"Doresti sa te dezabonezi?",
    ALARM_UNSUBSCRIBED:"Te-ai dezabonat cu succes",
    ASIDE_MENU_CASHLESS_SALES:"Vanzari fara numerar",
    FILTERED_CASHLESS_PAYMENTS:"Ai selectat plati fara numerar",
    REFUND_DIALOG_TITLE:"Doresti sa restitui tranzactia?",
    REFUND_DIALOG_SUBTITLE:"Suma poate fi mai mica sau egala cu suma transferata",
    REFUND:"Restituire",
    INPUT_NOT_VALID:"Valoarea introdusa nu este corecta",
    REFUND_SUCCESSFULLY:"Restituirea pentru plata selectata s-a realizat cu succes",
    USER:"Utilizator",
    TRANSACTION_ID:"Referinta PSP",
    DEVICE_ID:"ID terminal",
    NET_AMOUNT:"Suma neta",
    REPORT_NAME:"Nume raport",
    TIME_FRAME:"Interval orar",
    SUB_POINT:"Selectati subpunctul",
    SUB_POINT_LIST_NOT_EXIST:"Lista subpuncte nu exista pentru spalatoria selectata",
    FACILITY_TYPE:"Tip locatie",
    MACHINE_NAME:"Nume utilaj",
    WASH_FACILITY_DETAILS:"Detalii spalatorie",
    WASH_BAY_DETAILS:"Detalii piste de spalare",
    DEVICES_INFO:"Lista echipamente",
    OPERATION_TIME_INFO:"Timp de operare",
    OPERATION_TIME_VACUUM_INFO:"Timp de operare pentru aspiratoare",
    OPERATION_TIME_ILLUMINATION_INFO:"Timp de operare pentru iluminare",
    AVAILABLE_TITLE:"Disponibil",
    UNAVAILABLE_TITLE:"Indisponibil",
    CURRENT_PROGRAM:"Programul curent",
    CREDITS:"Credite",
    DEVICE_NAME:"Nume echipament",
    ACTIVE_ALARMS:"Alerte active",
    ALL_DAY:"Toata ziua",
    OPERATING_TIME_WASH_FACILITY:"Sistem de spalare self-service",
    OPERATING_TIME_VACUUMS:"Aspiratoare",
    OPERATING_TIME_ILLUMINATION:"Iluminare",
    OPERATION_COUNTERS:"Contoare functionare",
    EDIT:"Editare",
    WASHING_PROGRAMS:"Programe de spalare",
    INFO:"Incident/ eveniment",
    STATISTIC:"Statistic",
    ROLLOVER_DOSING:"Dozaj",
    ROLLOVER_SPEED:"Viteze",
    ROLLOVER_RESETS:"Resetare portal de la distanta",
    ROLLOVER_RESETS_INFO:"Resetarea de la distanta trebuie sa fie in acord cu reglementarile locale. Important: Inainte sa resetezi, asigura-te ca portalul este gol.",
    RESET_ROLLOVER:"Resetare portal",
    OPEN_DOOR_ROLLOVER:"Deschide",
    ROLLOVER_OPEN_DOOR_INFO:"Deschide usa culuarului de spalare. Cu atentie.",
    ROLLOVER_OPEN_DOOR:"Deschide usa",
    APPLY_DOSING_CHANGES:"Aplica modificari de dozaj",
    APPLY_SPEED_CHANGES:"Aplica modificari de viteza",
    ACTUATION_SUCCESS:"Solicitare transmisa",
    REMAINING_TIME:"Timp ramas",
    OPEN_24H:"Deschis 24 ore",
    CLOSE_24H:"Inchis 24 ore",
    VALIDATION_OPERATION_TIME:"Formatul nu este corect. Foloseste hh:mm",
    ROLLOVER:"Portal",
    UPDATE_WASHING_PROGRAM:"Actualizeaza programul de spalare",
    UPDATE_ACTUATORS:"Actualizeaza dispozitivele de actionare",
    OPEN_ROLOVER_DOOR_TITLE:"Doresti sa deschizi usa portalului?",
    OPEN_ROLOVER_DOOR_CONTENT:"Esti sigur ca doresti sa deschizi usa?",
    RESET_ROLOVER_TITLE:"Doresti sa resetezi portalul?",
    RESET_ROLOVER_CONTENT:"Esti sigur ca doresti sa resetezi portalul?",
    G0:"{{brand === 'r2w' ? 'Pista 0' : 'Pista 1'}}",
    G1:"{{brand === 'r2w' ? 'Pista 1' : 'Pista 2'}}",
    G2:"{{brand === 'r2w' ? 'Pista 2' : 'Pista 3'}}",
    G3:"{{brand === 'r2w' ? 'Pista 3' : 'Pista 4'}}",
    G4:"{{brand === 'r2w' ? 'Pista 4' : 'Pista 5'}}",
    G5:"{{brand === 'r2w' ? 'Pista 5' : 'Pista 6'}}",
    G6:"{{brand === 'r2w' ? 'Pista 6' : 'Pista 7'}}",
    G7:"{{brand === 'r2w' ? 'Pista 7' : 'Pista 8'}}",
    G8:"{{brand === 'r2w' ? 'Pista 8' : 'Pista 9'}}",
    G9:"{{brand === 'r2w' ? 'Pista 9' : 'Pista 10'}}",
    G10:"{{brand === 'r2w' ? 'Pista 10' : 'Pista 11'}}",
    U0:"{{brand === 'r2w' ? 'Aspirator 0' : 'Aspirator 1'}}",
    U1:"{{brand === 'r2w' ? 'Aspirator 1' : 'Aspirator 2'}}",
    U2:"{{brand === 'r2w' ? 'Aspirator 2' : 'Aspirator 3'}}",
    U3:"{{brand === 'r2w' ? 'Aspirator 3' : 'Aspirator 4'}}",
    U4:"{{brand === 'r2w' ? 'Aspirator 4' : 'Aspirator 5'}}",
    U5:"{{brand === 'r2w' ? 'Aspirator 5' : 'Aspirator 6'}}",
    U6:"{{brand === 'r2w' ? 'Aspirator 6' : 'Aspirator 7'}}",
    U7:"{{brand === 'r2w' ? 'Aspirator 7' : 'Aspirator 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Alert center report created by selected site from dashboard",
    ALERT_CENTER_TITLE_BY_FACILITY:"Alert center report created by selected facility from dashboard",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Raportul centrului de alerta",
    ERROR_MESSAGE_403:"Nu ai dreptul de a utiliza acest apel api. Eroare Cod: 403",
    LAST_ACTIVE_PROGRAM:"Programul activ / Ultimul program activ",
    PROGRAM_ID:"Numarul programului",
    PROGRAM_PRICE:"Pretul programului",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Necesita reumplerea",
    EMPTY_CHEMICAL_LEVEL:"Gol",
    CHEMICAL_LEVEL:"Nivelul de detergent (%)",
    ROLLOVER_STATUS:"Status portal",
    ROLLOVER_STATUS_CODE_0:"Spalarea nu functioneaza momentan",
    ROLLOVER_STATUS_CODE_1:"In afara programului de functionare",
    ROLLOVER_STATUS_CODE_2:"Introducerea programului este permisa",
    ROLLOVER_STATUS_CODE_3:"Pozitioneaza-ti vehicolul",
    ROLLOVER_STATUS_CODE_4:"Mergi in fata",
    ROLLOVER_STATUS_CODE_5:"Mergi in spate",
    ROLLOVER_STATUS_CODE_6:"Opreste",
    ROLLOVER_STATUS_CODE_7:"Spalare in curs",
    ROLLOVER_STATUS_CODE_8:"Spalarea s-a terminat",
    ROLLOVER_STATUS_CODE_9:"Spalare in curs (tact)",
    ROLLOVER_STATUS_CODE_10:"Iesire cu spatele",
    ROLLOVER_STATUS_CODE_11:"Oprire de urgenta",
    ROLLOVER_STATUS_CODE_12:"Iesire cu fata",
    ROLLOVER_STATUS_CODE_13:"Degivrare activa",
    ROLLOVER_STATUS_CODE_14:"Butonul de siguranta din fata este activat",
    ROLLOVER_STATUS_CODE_15:"Butonul de siguranta din spate este activat",
    ROLLOVER_STATUS_CODE_16:"Butonul de siguranta din stanga fata este activat",
    ROLLOVER_STATUS_CODE_17:"Butonul de siguranta din dreapta fata este activat",
    ROLLOVER_STATUS_CODE_18:"Butonul de siguranta din stanga spate este activat",
    ROLLOVER_STATUS_CODE_19:"Butonul de siguranta din dreapta spate este activat",
    ROLLOVER_STATUS_CODE_20:"Vehicolul este pozitionat prea mult in partea stanga",
    ROLLOVER_STATUS_CODE_21:"Vehicolul este pozitionat prea mult in partea dreapta",
    ROLLOVER_STATUS_CODE_22:"Usa din stanga nu este inchisa",
    ROLLOVER_STATUS_CODE_23:"Usa din dreapta nu este inchisa",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, programul de spalare este selectat gresit",
    ROLLOVER_STATUS_CODE_25:"Senzor claxon",
    ROLLOVER_STATUS_CODE_98:"Modul de ajustare / manual",
    ROLLOVER_STATUS_CODE_99:"Status necunoscut",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Cod status nedefinit",
    ALARM:"Defectiune critica",
    NO_ALARM:"Nu sunt erori critice",
    SOFTWARE_VERSION:"Versiune software",
    SOFTWARE_DATE:"Data software",
    SITE_ADDRESS:"Adresa locatie",
    SECONDS:"Secunde",
    SERVICE_PART_NAME:"Numele serviciului:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Contor functionare si service",
    OPERATION_COUNTER:"Contor functionare",
    SERVICE_COUNTER:"Contor service",
    FAULT_CODE:"Cod alerta",
    PRESSURE_TITLE:"Presiune aer",
    TIME_TITLE:"Ora curenta",
    COUNTRY_TITLE:"Tara",
    CITY_TITLE:"Orasul",
    REGION_TITLE:"Regiunea",
    SELECT_POINTS_TO_SEARCH:"Punctele selectate ...",
    LOGS_HISTORY:"Istoric modificari parametri",
    ACTUATOR_REFERENCE:"Actuator referinta",
    ACTUATOR_VALUE:"Actuator valoare",
    POINT_ID:"Point id",
    VALIDATION_NOT_VALID_RANGE:"Interval incorect",
    ENABLE_ROLLOVER_RESET:"Bifand aceasta casuta confirmi ca ai citit si esti de acord cu instructiunile privind siguranta.",
    CHANGE_OF_PARAMETERS:"Modificare de parametri",
    SELECT_OPTIONS:"Selecteaza optiunile",
    AUTOMATIC:"Automat",
    DESALTING:"Functia de desalinizare (dedurizare)",
    SEASON_WASH:"Programe de spalare in functie de sezon",
    SPRING_PROGRAM:"Programe de spalare primavara",
    SUMMER_PROGRAM:"Programe de spalare vara",
    AUTUMN_PROGRAM:"Programe de spalare toamna",
    WINTER_PROGRAM:"Programe de spalare iarna",
    DOOR_CONTROL:"Controlul usii",
    SUMMER_DOOR_CONTROL:"Vara, operat cu control poarta in modul vara",
    WINTER_DOOR_CONTROL:"Iarna, operat cu control poarta in modul iarna",
    APPLY_PARAMETERS_CHANGES:"Aplica modificarile de parametri",
    WORKING_SCHEDULES:"Program de functionare",
    HOLIDAY_SCHEDULES:"Program de sărbători",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Zilele libere pentru locatie au fost create cu succes",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Zilele libere pentru locatie au fost actualizate cu succes",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Zilele libere pentru locatie au fost sterse",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Programul de functionare a fost transmis cu succes",
    HOLIDAY_SUCCESSFULLY_DELETED:"Zilele libere au fost sterse",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:" CWB3_3_0_0_Trans",
    CWB3_3_1_0:" CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Nivel scazut agent de uscare",
    CHEM_LEVEL_LOW_SHAMPOO:"Nivel scazut sampon",
    CHEM_LEVEL_LOW_FOAM:"Nivel scazut spuma",
    CHEM_LEVEL_LOW_WAX_1:"Nivel scazut ceara",
    CHEM_LEVEL_LOW_POLISH_1:"Nivel scazut polish",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Nivel scazut agent spalare roti",
    CHEM_LEVEL_LOW_WAX_2:"Nivel scazut ceara",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Nivel scazut luciu de roti",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Nivel scazut solutie indepartare insecte",
    CHEM_LEVEL_LOW_POLISH_2:"Nivel scazut polish",
    CHEM_LEVEL_LOW_INTENSIVE:"Nivel scazut intensiv",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Nivel scazut ploaie spuma",
    CHEM_LEVEL_DRYING_AGENT:"Nivel agent de uscare",
    CHEM_LEVEL_SHAMPOO:"Nivel sampon",
    CHEM_LEVEL_FOAM:"Nivel spuma",
    CHEM_LEVEL_WAX_1:"Nivel ceara",
    CHEM_LEVEL_POLISH_1:"Nivel polish",
    CHEM_LEVEL_RIM_CLEANER:"Nivel agent curatare jenti",
    CHEM_LEVEL_WAX_2:"Nivel ceara",
    CHEM_LEVEL_TYRE_SHINE:"Nivel luciu de roti",
    CHEM_LEVEL_INSECT_REMOVER:"Nivel solutie indepartare insecte",
    CHEM_LEVEL_POLISH_2:"Nivel polish",
    CHEM_LEVEL_INTENSIVE:"Nivel intensive",
    CHEM_LEVEL_FOAM_RAIN:"Nivel ploaie spuma",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Service counter roof-brush lifting belt",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Service counter dryer lifting belt",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Service counter motor cable roof-brush",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Service counter fresh water pump service",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Service counter pump service used water",
    DRYING_AGENT:"Agent de uscare",
    FOAM_DRYING_AGENT:"Agent de uscare spuma",
    SHAMPOO:"Sampon",
    FOAM:"Spuma",
    BRUSH_FOAM:"Pre-spalare",
    WAX_1:"Ceara",
    FOAM_WAX_1:"Ceara spumata",
    POLISH_1:"Polish",
    RIM_CLEANING:"Curatare jenti",
    WAX_2:"Ceara",
    FOAM_WAX_2:"Ceara spumata",
    TYRE_SHINE:"Luciu de roti",
    INSECT_REMOVER:"Solutie indepartare insecte",
    POLISH_2:"Polish",
    INTENSIVE_BASIC:"Intensive basic",
    INTENSIVE_SIDE:"Intensive side",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensive roof spray bar",
    TAR_REMOVER:"Indepartare reziduu",
    UNDER_CHASSIS_CONVERSATION:"Spalare sub sasiu",
    STATIONARY_PRE_SPRAY_ARCH:"Stationary pre-spray arch",
    FOAM_RAIN:"Ploaie spuma",
    PRE_CLEANING:" Pre-cleaning",
    BRUSH:"Perie",
    CARE:"Ingrijire",
    DRYING:"Uscare",
    DRYING_LOW_NOISE:"Uscare cu zgomot redus",
    INTENSIVE_CLEANING:"Curatare intensiva",
    BRUSH_CLEANING:"Curatare cu perie",
    EMPTY_RUN:"Functionare in gol",
    DRYING_AID:"Drying aid",
    WAX:"Ceara",
    FOAM_WASH:"Spalare cu spuma",
    POLISH:"Polish",
    FOAM_POLISH:"Spuma pentru polish",
    WHEEL_CLEANING:"Curatare roti",
    HIGH_PRESSURE_ROOF:"Inalta presiune pentru acoperis",
    HIGH_PRESSURE_SIDE:"Inalta presiune pentru laterale",
    DRYER_FORWARD:"Uscator pentru partea din fata",
    DRYER_BACKWARD:"Uscator pentru partea din spate",
    DELETE_ALL_HOLIDAYS:"Sterge toate zilele libere pentru locatia selectata",
    CREATE_NEW_HOLIDAY:"Creaza o noua",
    RESET_INPUTS:"Sterge toate zilele libere introduse",
    TWENTY_FOUR_HOURS_OPEN:"Deschis 24 ore",
    EVERY_YEAR:"Anual",
    DELETE_HOLIDAY:"Sterge zilele libere",
    ADD_NEW_HOLIDAY:"Adauga o noua zi libera",
    HOLIDAYS_LIST:"Lista zilelor libere existenta",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Stergi toate zilele libere pentru locatia selectata?",
    VALIDATION_HOLIDAY_DATE:"Formatul nu este corect. Foloseste formatul mm-dd",
    FOR_DATE:"Pentru data",
    WITH_ID:"Cu ID",
    FROM_HOURS:"De la (ora)",
    FROM_MINUTES:"De la (min)",
    TO_HOURS:"Pana la (ora)",
    TO_MINUTES:"Pana la (min)",
    NOT_MATCH:"Nu se potriveste",
    START:"De la",
    STOP:"Pena la",
    DAILY_TIME:"Lista 24 ore",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Setare timp individual",
    PROGRAM_NOT_STARTED:"Programul nu a inceput inca",
    JETWASH:"Sistem de spalare self-service",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"Boxa spalare: Numarul de ore per program de spalare pentru fiecare pista si in total",
    KARCHER_REPORT_9:"Boxa spalare: Venitul total per pista de spalare si in total",
    KARCHER_REPORT_10:"Contor jetoane per jetoniera",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Pompa apa proaspata",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Pompa de apa procesata",
    OPERATION_COUNTER_HP_PUMP_1:"Pompa inalta presiune 1",
    OPERATION_COUNTER_HP_PUMP_2:"Pompa inalta presiune 2",
    RELEASE_NOTES:"Versiunile app si notele de la lansare",
    BACKEND_RELEASE_NOTES:"Note la lansarea platformei:",
    FRONTEND_RELEASE_NOTES:"Note la lansarea aplicatiei web:",
    SELECTED_FACILITY_TIMEZONE:"Fusul orar pentru locatia selectata:",
    REFRESH_PAGE:"Reimprospateaza pagina",
    REFRESH_MAPS:"Reimprospateaza harta",
    PUMPS:"Pompe",
    RUN_TIME:"Timp de functionare",
    RUN_TIME1:"Timp de functionare 1",
    RUN_TIME2:"Timp de functionare 2",
    PROGRAM_RUNTIME_ACTUATOR:"Actuator for run time",
    PROGRAM_RUNTIME_ACTUATOR_1:"Actuator for run time 1 ",
    PROGRAM_RUNTIME_ACTUATOR_2:"Actuator for run time 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Valoarea minima este 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Valoarea maxima este 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Foloseste formatul de pret x,xx",
    ACTUATION_NOT_ALLOWED:"Actionarea nu este permisa pentru rolul actual de utilizator",
    MAINTENANCE_DAYS:"Zile de mentenanta",
    MAINTENANCE_WASHES:"Spalari de mentenanta",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Venit total POS",
    PROPAGATE:"Procesare",
    ALL_DAY_HOURS_SELECTOR:"Tip seletor 24 ore",
    GET_OPERATING_TIME_FROM_SITE:"Setare orar de functionare",
    USER_NOT_VALID:"Utilizatorul nu este valid. Incearca un alt utilizator.",
    VERIFIED:"Verificat",
    RESEND_VERIFICATION_MAIL:"Retrimite email de verificare",
    RETURN_TO_DASHBOARD:"Reveniti la meniul principal",
    ERROR_PAGE_BAD_REQUEST:"400 Solicitare gresita.",
    WASHES:"Numarul de spalari",
    TIME_TO_SERVICE:"Timp de service/ functionare",
    ACCOUNT_ALREADY_ACTIVATED:"Contul a fost deja activat",
    DEVICE_EVENTS:"Evenimente dispozitiv",
    DEVICE_EVENTS_LOG_PULLED:"Jurnal de evenimente extras pentru dispozitiv",
    EVENTS_PULL_DATE:"Timpul evenimentelor extrase:",
    DEVICE_EVENTS_REFRESH:"Extrage datele noi ale evenimentelor",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problemă de conexiune cu socket-urile web. Încercați să reîncărcați pagina.",
    INSTALLATION_DATE:"Data instalării mașinii",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Ceară caldă",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Spălare cu presiune înaltă",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Spumă puternică pentru jante",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Spumă puternică",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Oprire",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Spălare cu spumă HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Spălare",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Îngrijire de top",
    INFO_TITLE:"Informații",
    FOAM_WAX1:"Ceara spumata",
    POLISH1:"Polish",
    WAX1:"Ceara",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Detaliile site-ului au fost actualizate cu succes",
    COMPANY:"Companie",
    FACILITY_HAS_CHANGER:"Aveți schimbător?",
    DISABLE_OFFLINE_ALARM:"Dezactivați alarmele R2W",
    ASIDE_WORKING_SCHEDULES:"Detalii site aplicație",
    TERMS_OF_SERVICE_R2W_TITLE:"Termenii și condițiile Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Termenii și condițiile Ready2Wash",
    DATA_PROCESSING_TITLE:"Date procesate",
    PRIVACY_POLICY_TITLE:"Politica de confidențialitate",
    READY_TO_PAY_TERMS_OF_SERVICE:"Termenii și condițiile Ready2Pay",
    TERMS_AND_SERVICES:"Termeni și servicii",
    HOURLY: "Orar",
    DAILY: "Zilnic",
    WEEKLY: "Săptămânal",
    MONTHLY: "Lunar",
    YEARLY: "Anual",
    DELETE_ITEM_SUCCESS:"Ați șters cu succes elementul",
    STATE: "Stare",
    AVAILABILITY_STATUS_1: "Unitate deschisă",
    AVAILABILITY_STATUS_2: "Unitate închisă (vacanță)",
    AVAILABILITY_STATUS_3: "Unitate închisă (program de funcționare)",
    AVAILABILITY_STATUS_4: "Unitate închisă (defecțiune)",
    AVAILABILITY_STATUS_5: "Unitate închisă (altceva)",
    AVAILABILITY_VACUUMS_STATUS_1: "Aspiratoarele nu sunt instalate",
    AVAILABILITY_VACUUMS_STATUS_2: "Aspiratoare deschise",
    AVAILABILITY_VACUUMS_STATUS_3: "Aspiratoare închise (vacanță)",
    AVAILABILITY_VACUUMS_STATUS_4: "Aspiratoare închise (program de funcționare)",
    AVAILABILITY_VACUUMS_STATUS_5: "Aspiratoare închise (defecțiune)",
    AVAILABILITY_VACUUMS_STATUS_6: "Aspiratoare închise (altceva)",
    ECOM_AMOUNT: "Total Ecom pentru toate locațiile",
    CAPTURED: "Înregistrat",
    DELETE_COMPANY_HISTORY_INFO:"Această acțiune va șterge toate datele rapoartelor companiei dumneavoastră. Această acțiune este ireversibilă.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Sunteți sigur că doriți să ștergeți definitiv toate datele rapoartelor?",
    VALUE_DATE: "Data valorii",
    KARCHER_EVENT_NAME_1: "Schimbătorul de căldură principal regenerat",
    KARCHER_EVENT_NAME_2: "Regenerarea schimbătorului de căldură principal finalizată",
    KARCHER_EVENT_NAME_3: "Material / număr de serie",
    KARCHER_EVENT_NAME_4: "Sistemul a fost dezinfectat",
    KARCHER_EVENT_NAME_5: "Pompa HP 1 dezinfectată",
    KARCHER_EVENT_NAME_6: "Pompa HP 2 dezinfectată",
    KARCHER_EVENT_NAME_7: "Pompa HP 3 dezinfectată",
    KARCHER_EVENT_NAME_8: "Pompa HP 4 dezinfectată",
    KARCHER_EVENT_NAME_9: "Pompa HP 5 dezinfectată",
    KARCHER_EVENT_NAME_10: "Stația de spălare 1 blocată",
    KARCHER_EVENT_NAME_11: "Stația de spălare 2 blocată",
    KARCHER_EVENT_NAME_12: "Stația de spălare 3 blocată",
    KARCHER_EVENT_NAME_13: "Stația de spălare 4 blocată",
    KARCHER_EVENT_NAME_14: "Stația de spălare 5 blocată",
    KARCHER_EVENT_NAME_15: "Stația de spălare 6 blocată",
    KARCHER_EVENT_NAME_16: "Stația de spălare 7 blocată",
    KARCHER_EVENT_NAME_17: "Stația de spălare 8 blocată",
    KARCHER_EVENT_NAME_18: "Actualizare începută",
    KARCHER_EVENT_NAME_19: "Actualizare finalizată",
    KARCHER_EVENT_NAME_20: "Pornire WS Reg",
    KARCHER_EVENT_NAME_21: "Finalizare WS Reg",
    KARCHER_EVENT_NAME_22: "Senzor WS 75%",
    KARCHER_EVENT_NAME_23: "Defecțiune tehnică",
    KARCHER_EVENT_NAME_24: "Defecțiune operațională",
    KARCHER_EVENT_NAME_25: "Dispozitiv pornit",
    KARCHER_EVENT_NAME_26: "Dispozitiv oprit",
    KARCHER_EVENT_NAME_27: "Cutia 1 închisă",
    KARCHER_EVENT_NAME_28: "Cutia 2 închisă",
    KARCHER_EVENT_NAME_29: "Cutia 3 închisă",
    KARCHER_EVENT_NAME_30: "Cutia 4 închisă",
    KARCHER_EVENT_NAME_31: "Cutia 5 închisă",
    KARCHER_EVENT_NAME_32: "Cutia 6 închisă",
    KARCHER_EVENT_NAME_33: "Cutia 7 închisă",
    KARCHER_EVENT_NAME_34: "Cutia 8 închisă",
    KARCHER_EVENT_NAME_35: "Stația pompei HP 1",
    KARCHER_EVENT_NAME_36: "Stația pompei HP 2",
    KARCHER_EVENT_NAME_37: "Stația pompei HP 3",
    KARCHER_EVENT_NAME_38: "Stația pompei HP 4",
    KARCHER_EVENT_NAME_39: "Stația pompei HP 5",
    KARCHER_EVENT_NAME_40: "Stația pompei HP 6",
    KARCHER_EVENT_NAME_41: "Stația pompei HP 7",
    KARCHER_EVENT_NAME_42: "Stația pompei HP 8",
    KARCHER_EVENT_NAME_43: "Arzător",
    KARCHER_EVENT_NAME_44: "Ventilatorul arzătorului",
    KARCHER_EVENT_NAME_45: "Pompa de apă caldă",
    KARCHER_EVENT_NAME_46: "Pompa de protecție împotriva înghețului",
    KARCHER_EVENT_NAME_47: "Pompa osmozei",
    KARCHER_EVENT_NAME_48: "Încălzire prin pardoseală",
    KARCHER_EVENT_NAME_49: "Încălzire furtun",
    KARCHER_EVENT_NAME_50: "Curățarea micro / jantelor",
    KARCHER_EVENT_NAME_51: "Pompa de spălare a șasiului",
    KARCHER_EVENT_NAME_52: "Pompa de spumă Booster",
    KARCHER_EVENT_NAME_53: "Aspirator 1",
    KARCHER_EVENT_NAME_54: "Aspirator 2",
    KARCHER_EVENT_NAME_55: "Aspirator 3",
    KARCHER_EVENT_NAME_56: "Aspirator 4",
    KARCHER_EVENT_NAME_57: "Aspirator 5",
    KARCHER_EVENT_NAME_58: "Aspirator 6",
    KARCHER_EVENT_NAME_59: "Aspirator 7",
    KARCHER_EVENT_NAME_60: "Aspirator 8",
    KARCHER_EVENT_NAME_61: "Aspirator 9",
    KARCHER_EVENT_NAME_62: "Aspirator 10",
    KARCHER_EVENT_NAME_63: "Aspirator 11",
    KARCHER_EVENT_NAME_64: "Aspirator 12",
    KARCHER_EVENT_NAME_65: "Pompa de curățare a jantelor",
    KARCHER_EVENT_NAME_66: "Pompa micro",
    KARCHER_EVENT_NAME_67: "Pompa intensivă",
    KARCHER_EVENT_NAME_68: "Turbina aspirator 1",
    KARCHER_EVENT_NAME_69: "Filtru aspirator 1",
    KARCHER_EVENT_NAME_70: "Turbina aspirator 2",
    KARCHER_EVENT_NAME_71: "Filtru aspirator 2",
    KARCHER_EVENT_NAME_72: "Turbina aspirator 3",
    KARCHER_EVENT_NAME_73: "Filtru aspirator 3",
    KARCHER_EVENT_NAME_74: "Turbina aspirator 4",
    KARCHER_EVENT_NAME_75: "Filtru aspirator 4",
    KARCHER_EVENT_NAME_76: "Turbina aspirator 5",
    KARCHER_EVENT_NAME_77: "Filtru aspirator 5",
    KARCHER_EVENT_NAME_78: "Turbina aspirator 6",
    KARCHER_EVENT_NAME_79: "Filtru aspirator 6",
    KARCHER_EVENT_NAME_80: "Turbina aspirator 7",
    KARCHER_EVENT_NAME_81: "Filtru aspirator 7",
    KARCHER_EVENT_NAME_82: "Turbina aspirator 8",
    KARCHER_EVENT_NAME_83: "Filtru aspirator 8",
    KARCHER_EVENT_NAME_84: "Turbina aspirator 9",
    KARCHER_EVENT_NAME_85: "Filtru aspirator 9",
    KARCHER_EVENT_NAME_86: "Turbina aspirator 10",
    KARCHER_EVENT_NAME_87: "Filtru aspirator 10",
    KARCHER_EVENT_NAME_88: "Turbina aspirator 11",
    KARCHER_EVENT_NAME_89: "Filtru aspirator 11",
    KARCHER_EVENT_NAME_90: "Turbina aspirator 12",
    KARCHER_EVENT_NAME_91: "Filtru aspirator 12",
    INSERT_TOKEN: "Introduceți token-urile și porniți serviciul",
    OPEN_SESSION: "Sesiune deschisă cu succes",
    IN_PROGRESS: "În desfășurare ...",
    TOKEN_INSERTED: "Token-urile au fost introduse cu succes",
    EXPIRED_SESSION: "Sesiunea a expirat",
    TWO_DIGIT_INTEGER_VALIDATION: "Utilizați un număr întreg de maximum două cifre",
    KARCHER_OPERATION_COUNTER_1: "Stație de spălare 1 pompă HP",
    KARCHER_OPERATION_COUNTER_2: "Stație de spălare 1 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_3: "Stație de spălare 1 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_4: "Stație de spălare 1 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_5: "Stație de spălare 1 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_6: "Stație de spălare 2 pompă HP",
    KARCHER_OPERATION_COUNTER_7: "Stație de spălare 2 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_8: "Stație de spălare 2 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_9: "Stație de spălare 2 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_10: "Stație de spălare 2 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_11: "Stație de spălare 3 pompă HP",
    KARCHER_OPERATION_COUNTER_12: "Stație de spălare 3 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_13: "Stație de spălare 3 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_14: "Stație de spălare 3 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_15: "Stație de spălare 3 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_16: "Stație de spălare 4 pompă HP",
    KARCHER_OPERATION_COUNTER_17: "Stație de spălare 4 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_18: "Stație de spălare 4 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_19: "Stație de spălare 4 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_20: "Stație de spălare 4 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_21: "Stație de spălare 5 pompă HP",
    KARCHER_OPERATION_COUNTER_22: "Stație de spălare 5 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_23: "Stație de spălare 5 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_24: "Stație de spălare 5 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_25: "Stație de spălare 5 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_26: "Stație de spălare 6 pompă HP",
    KARCHER_OPERATION_COUNTER_27: "Stație de spălare 6 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_28: "Stație de spălare 6 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_29: "Stație de spălare 6 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_30: "Stație de spălare 6 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_31: "Stație de spălare 7 pompă HP",
    KARCHER_OPERATION_COUNTER_32: "Stație de spălare 7 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_33: "Stație de spălare 7 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_34: "Stație de spălare 7 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_35: "Stație de spălare 7 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_36: "Stație de spălare 8 pompă HP",
    KARCHER_OPERATION_COUNTER_37: "Stație de spălare 8 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_38: "Stație de spălare 8 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_39: "Stație de spălare 8 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_40: "Stație de spălare 8 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_41: "Pompă cu osmoză",
    KARCHER_OPERATION_COUNTER_42: "Generator de apă caldă",
    KARCHER_OPERATION_COUNTER_43: "Pompă de protecție împotriva înghețului",
    KARCHER_OPERATION_COUNTER_44: "Cartușe de filtrare WSO",
    KARCHER_OPERATION_COUNTER_45: "Pompă de încălzire stație de spălare",
    KARCHER_OPERATION_COUNTER_46: "Pompă de apă caldă",
    KARCHER_OPERATION_COUNTER_47: "Încălzitor pentru furtunuri de spumă",
    KARCHER_OPERATION_COUNTER_48: "Pompă pentru spălarea roților",
    KARCHER_OPERATION_COUNTER_49: "Pompă de microemulzie",
    KARCHER_OPERATION_COUNTER_50: "Pompă pentru spumă intensă",
    KARCHER_OPERATION_COUNTER_51: "Aspirator 1 turbină 1",
    KARCHER_OPERATION_COUNTER_52: "Aspirator 1 filtru 1",
    KARCHER_OPERATION_COUNTER_53: "Aspirator 1 turbină 2",
    KARCHER_OPERATION_COUNTER_54: "Aspirator 1 filtru 2",
    KARCHER_OPERATION_COUNTER_55: "Aspirator 2 turbină 1",
    KARCHER_OPERATION_COUNTER_56: "Aspirator 2 filtru 1",
    KARCHER_OPERATION_COUNTER_57: "Aspirator 2 turbină 2",
    KARCHER_OPERATION_COUNTER_58: "Aspirator 2 filtru 2",
    KARCHER_OPERATION_COUNTER_59: "Aspirator 3 turbină 1",
    KARCHER_OPERATION_COUNTER_60: "Aspirator 3 filtru 1",
    KARCHER_OPERATION_COUNTER_61: "Aspirator 3 turbină 2",
    KARCHER_OPERATION_COUNTER_62: "Aspirator 3 filtru 2",
    KARCHER_OPERATION_COUNTER_63: "Aspirator 4 turbină 1",
    KARCHER_OPERATION_COUNTER_64: "Aspirator 4 filtru 1",
    KARCHER_OPERATION_COUNTER_65: "Aspirator 4 turbină 2",
    KARCHER_OPERATION_COUNTER_66: "Aspirator 4 filtru 2",
    KARCHER_OPERATION_COUNTER_67: "Aspirator 5 turbină 1",
    KARCHER_OPERATION_COUNTER_68: "Aspirator 5 filtru 1",
    KARCHER_OPERATION_COUNTER_69: "Aspirator 5 turbină 2",
    KARCHER_OPERATION_COUNTER_70: "Aspirator 5 filtru 2",
    KARCHER_OPERATION_COUNTER_71: "Aspirator 6 turbină 1",
    KARCHER_OPERATION_COUNTER_72: "Aspirator 6 filtru 1",
    KARCHER_OPERATION_COUNTER_73: "Aspirator 6 turbină 2",
    KARCHER_OPERATION_COUNTER_74: "Aspirator 6 filtru 2",
    KARCHER_OPERATION_COUNTER_75: "Goliți apa de condens din compresor",
    KARCHER_OPERATION_COUNTER_76: "Verificați sistemul de protecție împotriva înghețului",
    KARCHER_OPERATION_COUNTER_77: "Ventilator arzător",
    KARCHER_OPERATION_COUNTER_78: "Pompă de spumă intensificată",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Lista de date este mai mare de 10000 de articole",
    KARCHER_POINT_NAME_1: "Sărbătoare",
    KARCHER_POINT_NAME_2: "Luni",
    KARCHER_POINT_NAME_3: "Marți",
    KARCHER_POINT_NAME_4: "Miercuri",
    KARCHER_POINT_NAME_5: "Joi",
    KARCHER_POINT_NAME_6: "Vineri",
    KARCHER_POINT_NAME_7: "Sâmbătă",
    KARCHER_POINT_NAME_8: "Duminică",
    KARCHER_POINT_NAME_9: "Aspiratoare Sărbătoare",
    KARCHER_POINT_NAME_10: "Aspiratoare Luni",
    KARCHER_POINT_NAME_11: "Aspiratoare Marți",
    KARCHER_POINT_NAME_12: "Aspiratoare Miercuri",
    KARCHER_POINT_NAME_13: "Aspiratoare Joi",
    KARCHER_POINT_NAME_14: "Aspiratoare Vineri",
    KARCHER_POINT_NAME_15: "Aspiratoare Sâmbătă",
    KARCHER_POINT_NAME_16: "Aspiratoare Duminică",
    KARCHER_POINT_NAME_17: "Iluminare Sărbătoare",
    KARCHER_POINT_NAME_18: "Iluminare Luni",
    KARCHER_POINT_NAME_19: "Iluminare Marți",
    KARCHER_POINT_NAME_20: "Iluminare Miercuri",
    KARCHER_POINT_NAME_21: "Iluminare Joi",
    KARCHER_POINT_NAME_22: "Iluminare Vineri",
    KARCHER_POINT_NAME_23: "Iluminare Sâmbătă",
    KARCHER_POINT_NAME_24: "Iluminare Duminică",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "Cod QR",
    ACCEPT_TERMS_AND_CONDITIONS: "Acceptă termenii și condițiile",
    CREATE_AND_PRINT_VOUCHERS: "Creează și imprimă vouchere",
    CODE_PREFIX_QUESTION: "Prefixul codului nu este introdus",
    CODE_PREFIX_QUESTION_TEXT: "Doriți să continuați fără prefix de cod?",
    ISSUED_DATE: "Data emiterii",
    VOUCHER_VALIDITY_DAYS: "Valabilitatea cuponului (zile)",
    VALIDATION_ONLY_NUMBERS: "Sunt permise doar numere",
    REPRINT_VOUCHERS: "Imprimați copia cuponului",
    EXPIRY_DATE: "Valabil până la"
  });
})();
